module.exports = __webpack_public_path__ + "static/media/TapToShowIn14Sept2020.bda6af51.gif";